import { Injectable } from '@angular/core';
import { WillsEmail } from './willsEmail';

@Injectable()
export class WillsEmailFormatterService {
  formatWillsEMail(willInformation: WillsEmail): String {
    const wi = willInformation;

    // This tabbing is important for the format of the final email sent
    return `
Name: ${wi.name}
Email: ${wi.customerEmail}
Phone: ${wi.phone}
Address:
${wi.address.line1}
${wi.address.state}
${wi.address.postcode}
Date of Birth: ${wi.dateOfBirth}
Local office: ${wi.localOffice}
Special Requirements: ${wi.specialRequirements}
Accepted Marketing Permission: ${wi.acceptedMarketingPermission ? 'YES' : 'NO'}
Accepted Privacy Conditions: ${wi.acceptedPrivacyConditions ? 'YES' : 'NO'}`;
  }
}



// WEBPACK FOOTER //
// ./app/services/notification/willsemailformatter.service.ts